import { SortOptions } from "@/api/sdk"
import ScrollHorizontalContainer from "@/components/Alpha/ScrollHorizontalContainer"
import ImageCardNavigator from "@/components/Explore/Gallery/ImageItem/ImageCardNavigator"
import { ImagesProvider } from "@/providers/ImagesProvider"
import { useExploreImagesInfiniteQuery } from "@/queries"

interface ExampleImagesProps {
  recipeId: string
  hasPrompt?: boolean
}

const ExampleImages = ({ recipeId, hasPrompt }: ExampleImagesProps) => {
  const { flattenData: mappedImagesExample = [] } = useExploreImagesInfiniteQuery({
    variables: {
      sortBy: SortOptions.MOSTFAVORITE,
      recipeIds: [recipeId],
      take: 8,
    },
  })

  if (mappedImagesExample.length === 0) return null

  return (
    <div className="p-4 md:p-6 pb-0 md:pb-0">
      <p className="text-sm mb-2 font-semibold text-atherGray-300">Some generated by community</p>
      <div className="w-full relative overflow-hidden">
        <div className="overflow-hidden max-w-full">
          <ImagesProvider images={mappedImagesExample}>
            <ScrollHorizontalContainer className="space-x-1 w-full">
              {mappedImagesExample?.map(image => {
                return (
                  <div key={image.id} className="shrink-0 flex h-[10rem]">
                    <ImageCardNavigator
                      isExplore
                      hiddenMenu
                      hiddenReaction
                      stretch
                      isDisabledInView
                      hiddenSelectPrompt={!hasPrompt}
                      className="h-full"
                      imgClassName="w-auto"
                      hiddenSelect
                      classNameItem="rounded-none"
                      filters={{
                        sortBy: SortOptions.MOSTFAVORITE,
                        recipeIds: [recipeId],
                        take: 8,
                        promptMode: true,
                      }}
                      data={image}
                    />
                  </div>
                )
              })}
            </ScrollHorizontalContainer>
          </ImagesProvider>
        </div>
      </div>
    </div>
  )
}

export default ExampleImages
